import type { Ref } from 'vue';
import type { AutopilotListFilter } from '@/composables/useAutopilotList';

/**
 * Reusable {@link AutopilotListFilter} builders. A filter is just a `{ schema, get, set }` descriptor,
 * so common controls (free-text search, enums, …) can be expressed once and dropped into any list's
 * `autopilotFilters`. Add more builders here as shared filter shapes emerge.
 */

/**
 * A free-text search filter backed by a string ref (e.g. a list's search bar). Setting it mutates
 * the ref, which should be bound to the list so it refetches.
 */
export function searchFilter(
  model: Ref<string>,
  description = 'Free-text search across the list; empty clears it.'
): AutopilotListFilter {
  return {
    schema: { type: 'string', description },
    get: () => model.value,
    set: (value) => {
      model.value = String(value ?? '');
    },
  };
}
